import Servico from './Servico'

class EspecialidadeServico extends Servico {
  constructor() {
    super('especialidade')
  }
}

export default EspecialidadeServico
